export default __webpack_public_path__ + "static/media/18-TheGetaway.d3ae47a6.jpeg";